import React from 'react'

import { IEscalationFactorQualitativeBarriers } from 'plugin-codaf-risk-ext-bowtie/types/reports'

import { Scrollbars } from '../../../../../generic/'
import { escalationFactorQualitativeBarriers } from '../../mock'

interface IProps {
    info?: IEscalationFactorQualitativeBarriers
}

export const EscalationFactorQualitativeBarriers: React.FC<IProps> = () => {
    const collumNames = [
        'resource',
        'bowtie code',
        'barrier id',
        'escalation factor barrier name',
        'efetividade',
        'DC',
        'status',
        'data/time'
    ]

    return (
        <div className="tableContainer customScroll">
            <table>
                <Scrollbars>
                    <tr>
                        {collumNames.map((collums, index) => {
                            return (
                                <th key={index} className={collums}>
                                    {collums}
                                </th>
                            )
                        })}
                    </tr>
                    {escalationFactorQualitativeBarriers.map((data, index) => {
                        return (
                            <tr key={index}>
                                <td valign="middle" style={{ width: '118px' }}>
                                    {data.resource}
                                </td>
                                <td valign="middle" style={{ width: '118px' }}>
                                    {data.bowtieCode}
                                </td>
                                <td valign="middle" style={{ width: '118px' }}>
                                    {data.barrierId}
                                </td>
                                <td valign="middle">{data.escalationFactorBarrierName}</td>
                                <td valign="middle" style={{ width: '123px' }}>
                                    {data.effectiveness}
                                </td>
                                <td valign="middle" style={{ width: '123px' }}>
                                    {data.dc}
                                </td>
                                <td valign="middle" style={{ width: '123px' }}>
                                    {data.status}
                                </td>
                                <td valign="middle" style={{ width: '123px' }}>
                                    {data.date}
                                </td>
                            </tr>
                        )
                    })}
                </Scrollbars>
            </table>
        </div>
    )
}
